<template>
<div class="chapter">
<div class="inner_page">
<div id="epigraph">
<div class="image" id="image2">
<p class="center"><span href="#/035imagecredits#page8" title="Link target outside of Sample"><img alt="" src="images/image-8.jpg"/></span></p>
</div>
<h1>EPIGRAPH</h1>
<p class="center">“A bat! That’s it! It’s an omen!”<br/><br/></p>
<p class="center">—Bruce Wayne, 1939</p>
<p class="center">—Michael Uslan, 1959, age 8</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005epigraph.vue?063175e2